import {lazy, Suspense, useEffect, useRef} from 'react'
import {dropTargetForElements} from '@atlaskit/pragmatic-drag-and-drop/element/adapter'

import {twMerge} from '@sdox/utils'
import {Loading} from '@sdox/ui'

import {useDesignDebugger} from '../Debugger'
import {useIsEditable} from '../DragAndDrop'

import type {ClassNameValue} from 'tailwind-merge'
import type {PropsWithChildren} from 'react'

export interface SectionContentProps extends PropsWithChildren {
  className?: ClassNameValue
}

const DummyDroppable = lazy(() => import('../DragAndDrop/DummyDroppable'))

export const SectionContent = (props: SectionContentProps) => {
  const isEditable = useIsEditable()
  // The dummy droppable is used for better sticky behavior of blocks in a page.
  if (isEditable) {
    return (
      <Suspense fallback={<Loading />}>
        <DummyDroppable>
          <SectionContentInner {...props} />
        </DummyDroppable>
      </Suspense>
    )
  }

  return <SectionContentInner {...props} />
}

const SectionContentInner = ({children, className}: SectionContentProps) => {
  const ref = useRef<HTMLDivElement>(null!)
  useDesignDebugger(ref, 'SectionContent')

  // TODO: add check for editor
  useEffect(() => {
    if (!ref.current) return

    const cleanup = dropTargetForElements({
      element: ref.current,
    })

    return cleanup
  }, [])

  return (
    <div
      ref={ref}
      className={twMerge('flex flex-col gap-spacing-48 @block-medium:gap-block-medium', className)}
    >
      {children}
    </div>
  )
}
